


























import {
  Component, Vue, Watch, mixins,
} from '@samclick-commons';
import SamclickMixins from '@/utils/mixins';
import { AuthorizationStore, Payload } from '@/state/modules';

class TermsAndConditionState {
        showDialog: boolean = false
}

    @Component({
      /**
         * Imported components
         * */
      components: {},
      /**
         * Stores values
         * */
      computed: {},
      /**
         * Component properties
         * */
      props: {
        showAgree: {
          type: Boolean,
          default: true,
          required: false,
        },
      },
    })
export default class TermsAndCondition extends mixins(SamclickMixins) {
        /**
         * Local state
         * */
        state = new TermsAndConditionState();

        /**
         * Watchers
         * */
        @Watch('componentState.var')
        sampleWatcher(newVal: string, oldVal: string) {

        }

        /**
         * Methods
         * */
        toggleDialog(show: false) {
          this.state.showDialog = show;
        }

        agree() {
          this.emitEventHandler('agree');
          this.toggleDialog(false);
        }

        disagree() {
          this.emitEventHandler('disagree');
          this.toggleDialog(false);
        }
        /**
         * Computed
         * */


        /**
         * Lifecycle hooks
         * */
        created() {
        }

        mounted() {
        }

        beforeUpdate() {
        }
}
